var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("span", { staticClass: "emd-text" }, [
        _vm._v(_vm._s(_vm.$t(_vm.value.name))),
      ]),
      _c("EmdSwitcher", {
        attrs: {
          id: _vm.openName,
          label: _vm.switchLabel,
          name: _vm.openName,
          disabled: _vm.disabled,
        },
        on: {
          change: function ($event) {
            return _vm.$v.value.open.$touch()
          },
        },
        model: {
          value: _vm.value.open,
          callback: function ($$v) {
            _vm.$set(_vm.value, "open", $$v)
          },
          expression: "value.open",
        },
      }),
      _c(
        "div",
        { staticClass: "date-period" },
        [
          _c(
            "emd-select",
            {
              attrs: { name: _vm.startName, disabled: _vm.formDisabled },
              on: {
                input: function ($event) {
                  return _vm.handleChange()
                },
              },
              model: {
                value: _vm.value.start,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "start", $$v)
                },
                expression: "value.start",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c(
                "option",
                { key: item + "-start", domProps: { value: item } },
                [_vm._v(" " + _vm._s(item) + " ")]
              )
            }),
            0
          ),
          _c(
            "span",
            {
              class: {
                to: true,
                disabled: _vm.formDisabled,
              },
            },
            [_vm._v(_vm._s(_vm.$t("to")))]
          ),
          _c(
            "emd-select",
            {
              class: {
                _state_error:
                  !_vm.$v.value.isHoursValid && _vm.$v.value.open.checked,
              },
              attrs: { name: _vm.endName, disabled: _vm.formDisabled },
              on: {
                input: function ($event) {
                  return _vm.handleChange()
                },
              },
              model: {
                value: _vm.value.end,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "end", $$v)
                },
                expression: "value.end",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c(
                "option",
                { key: item + "-end", domProps: { value: item } },
                [_vm._v(" " + _vm._s(item) + " ")]
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }